<template>
  <div class="block">
    <el-tag>选择账户： </el-tag>
    <div class="block">
      <el-cascader
        v-model="userUalue"
        :options="options1"
        filterable></el-cascader>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择汇总方式：</el-tag>

    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择层级：</el-tag>
    <el-select v-model="values" placeholder="请选择">
      <el-option
        v-for="items in level"
        :key="items.value"
        :label="items.label"
        :value="items.value">
      </el-option>
    </el-select>

    <el-divider direction="vertical"></el-divider>
    <el-tag>输入起止日期：</el-tag>

    <el-date-picker
      v-model="value1"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyyMMdd"
      :picker-options="pickerOptions"
      @change="chooseTimeRange">
    </el-date-picker>
    <el-button type="primary" v-on:click="exportExcel" round>导出</el-button>
    <el-button type="primary" v-on:click="getDataList" :disabled="isDisable" round>查询</el-button>
    <el-divider></el-divider>

    <el-table
      v-loading="loading"
      element-loading-text="拼命查询中..."
      stripe
      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="datas"
      id="exportTab"
      :summary-method="getSummaries"
      show-summary
      style="width: 100%">
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        fixed
        prop="campaignName"
        label="计划名称"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupId"
        label="广告组ID"
        width="100">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupName"
        label="广告组名称"
        width="200">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementId"
        width="120"
        label="广告ID">
      </el-table-column>
      <el-table-column
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementName"
        label="广告名称"
        width="300">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        prop="creativeId"
        label="创意ID">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="placeType"
        label="广告位类型">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="cvType"
        label="转化类型">
      </el-table-column>
      <el-table-column
        v-if="['ACCOUNT'].includes(this.values)"
        prop="reportDate"
        width="120"
        label="按天维度查询时返回">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="uuid"
        width="120"
        label="账户id">
      </el-table-column>
      <el-table-column
        sortable
        prop="nameid"
        width="120"
        label="名称">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignId"
        width="120"
        label="计划id">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        prop="balance"
        width="100"
        label="现金余额">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        label="撞线警告">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.flag">警告警告 </el-tag>
          <el-tag type="success" v-else-if="!scope.row.flag">平安 </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="showCount"
        label="曝光量"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="clickCount"
        label="点击量">
      </el-table-column>
      <el-table-column
        prop="CTR"
        :formatter="ChangeToPercentage"
        label="点击率">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        width="80"
        prop="spent"
        label="花费">
      </el-table-column>
      <el-table-column
        sortable
        prop="formsubmitCount"
        label="表单提交量">
      </el-table-column>
      <el-table-column
        sortable
        prop="but"
        label="表单成本"
      >
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        prop="dailyBudget"
        :formatter="rule1"
        label="日限额">
      </el-table-column>
      <el-table-column
        prop="customPayCount"
        label="自定义付费数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdyff"
        label="自定义付费数成本">
      </el-table-column>
      <el-table-column
        prop="reactivation"
        label="自定义拉活数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdylh"
        label="自定义拉活数成本">
      </el-table-column>
      <el-table-column
        prop="customRetainCount"
        label="自定义次留">
      </el-table-column>
      <el-table-column
        prop="zdycl"
        label="自定义次留成本">
      </el-table-column>
      <el-table-column
        sortable
        prop="CVR"
        :formatter="ChangeToPercentage"
        label="转化率">
      </el-table-column>
      sortable
      <el-table-column
        prop="CLR"
        :formatter="ChangeToPercentage"
        label="次留率">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        fixed="right"
        label="计划状态"
        prop="pauseState"

      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.pauseState"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="changeSwitch($event,scope.row,scope.$index)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" v-if="flag" type="text" size="small">查看</el-button>
          <el-button @click="edit(scope.row)" v-if="dingshi" type="text" size="small">定时</el-button>
          <el-button @click="edit1(scope.row)"  v-if="xiane" type="text" size="small">限额</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="时段成本"
      :visible.sync="table"
      direction="rtl"
      size="50%">
      <el-table :data="HourList"
                v-loading="loading"
      >
        <el-table-column property="reportTime" label="日期" width="150"></el-table-column>
        <el-table-column property="campaignName" label="计划名称" width="200"></el-table-column>
        <el-table-column property="nameid" label="名称"></el-table-column>
        <el-table-column property="spent" label="花费"></el-table-column>
        <el-table-column property="formsubmitCount" label="表单提交量" width="200"></el-table-column>
        <el-table-column property="chengben" label="成本" width="200"></el-table-column>
      </el-table>
    </el-drawer>
    <el-dialog title="修改开启时间" :visible.sync="dialog">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="updateTime(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改日限额" width="500px"  :visible.sync="dialog1">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="不限" >
          <el-tag>不限制任何额度</el-tag>
        </el-tab-pane>
        <el-tab-pane  name="second" label="自定义">
          <el-input v-model="money" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元/天</el-tag>

        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="updateEd(form)">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {


  data() {
    return {

      loading:false,
      isDisable:false,
      userUalue:'',
      options1: [{

        value: 'tangtang',
        label: '唐唐  ',
        children: [{
          value: 'fjwc',
          label: '福建挖财'
        },
          ,{
          value: "zer",
            label: '助尔融'
          }
          ,{
            value: 'bbkj',
            label: '好宝宝砍价'
          },{
          value: 'bxhx',
            label: '百寻唤醒'
          },{
          value:'hjh',
            label: '化橘红'
          },{
            value:'kmcs',
            label: '漫酷测算'
          },{
            value: 'ycsq',
            label: '雅宸三七'
          }
          ]
      }],
      options: [{
        value: 'DAY',
        label: '按天汇总'
      }, {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }
      ],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],
      hjh:['de9c3a96e9bd6248713d','8197fabc349f3706e44f','6cd4503a7adc2c8ecd91','46312aa6982bfb1e4191'],
      hjhtoken:['95543ea93800fa514a9110abba375e098441033cf66d9e54ab6d9ed00af1f19e'],
      ycsq:['bf76e2f3665fd1df2588','64d38038434b163595ec','516829fa963025278e35','c0f1d8ef9a0f20a62af3','79d0210099bcdfe7a0dd',
        'a7911b191bfa0d0fa1df',
        'c3391b2f130e24347656',
        '4ff4b80eff7aabbb3cc0',
        'bcf12627afd9b64499d1',
        'b5c6188340634ada30a7',
        'aa9d90f0e828c9fb539b',
        '887aec7cd4a7b7cddb1e',
        'a19bca3db8541f4d578a',
        'a4d715bdbf2236f43439',
      ],
      ycsqtoken:['48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e'],
      bxhx:[
        '3311e2241168e07fdbd1',
        '0acf8fa07a3c8f99ace9',
        '0effdf16316aafcdb9e5',
        'a3fd377a202e73675c22',
        '1bd734bcc9de78a44f40',
        '184d79b03ad8b2a6aff4',
        'f72c84b93eee0f94a1df',
        '4a23d84108822e6cb4ef',
        '184c40aa9e9d50c3d4b6',
        'ad409e7831fa35859547',
      ],
      bxhxtoken:['7ebfe748f5b710d8594737aac859d636b4e9705fe6894b7bd78b00c6659a5f27'],
      ttgx:['302f2aed267d613e6b72','04ec3fd52f0a03708146','42ac042d7aaca972fa23','ca0a221c99cf8d0abc28','1b8d5cf361f7f8fbfb26'],
      ttgxtoken:['d0cfb5b854c08aa30f2e4a871347f59aad0e22c35b9ebe567a8a9547c8c1239c'],
      bbkj:['22b811be804b838e1696',
        'c8f6658850ebca3cdf9b',
        '5f366cfa13a03d74cf5f',
        'a52528ff997445f58950',
        '604511525745489db137',
        '988003bb4feaeb1bef07',
        '021c615829deb9731522',
        '5bd75506f364e3ac5c63',
        '599ce3b956f0729621d2',
        'a9cacf81559c9680cf95',
        '0bebee59bdc1e10d292b',
        '06e1789983c9612ec7d7',
        '5ecd5c27104dac720ae9',
        '0d3af6dacb8738989cd6',
        '2b87518caffc02801902',
        '50ee73566fa5fc9230ca',
        '185bba21d3b3c63d6542',
        '96783e74dd7ddfe2d946',
        '43611efcb7af222dc60c',
        'ed89b48f72fda0f73914',
        '7041b6642152d43b4c9f',],

      bbkjtoken:['edce2a9fe9b14c4385921a2aa99c509cbbfc83cdaaf5f76c3c7e648730bbaaa4'],
      bxm:['195bbfc16bab5b65ff8b',
        'e5030ea6ac4001018dad',
        '9ef4ed842437c673b089',
        'e68392e47f2334c337b2',
        '8b2f26efb30a7be6e8df',
        'c5a30a7da8616f7b8937',
        '4168d3b7b2e398041cbb',
        '6942d768ed1d3d88e928',
        '934386cdeb89993056a9',
        '7e0fa2d56f7c512fb78e',
      ],
      jhcstoken:['d0a9fb1f975a65da1757fab3db4f5acf5ba2a8edf94bac6cd7f92dbfe9a9fffa'],
      jhcs:['e53603d33cd644d4bd4e',
        '3b8c506f9cdc1c4f33d3',
        '53e39311bb5465890f9e',
        '4d60736d4cb4236acf0a',
        '345e3701d4bf327f8556','082b115ff130516257aa','7b0f889b04ce3013d7fc','d38450efb00309b1e2b7'],
      //数据
      ljs:['03ac01639b584c994b02',
        'e50a7e1004cf02a2a333',
        '699c4d04827bc28379be',
        '1107f01e718602733104',
        'e88ebfa1fe57c3a0e581',
        '4aca573255c3974548da',
        '966b43381f4e8f01e1e3',
        '0bea0ac8872a727db96a',
        '0a2e61abf4b092af26cd'],
      ljstoken:['d94b163c7c640fb3efecc297bfe7cc83a43469baf19964a89dfec075d2e79c11'],

      bxmtoken:['b2ccbbe22a1e7f2cfe1be4a81aac4cb1beb155db5f5863c143d0600dd47dd63d'],
      xiaoqing:['1b39ec617071e23de1c865ea772c1eace6392f195781a9128405a0d19920ea3d','e02e2618fc793dc152d82ce2ded524f97d775e108b295a1ce338117ca096fd5f',
        'cb40eea503b274dadca8c71634393d407af24c9c0c2aa095c7c8665ec07f1d4e','b76f84d0eb68aea6faee58e82ad7cc652f7187eb23ef1b9d3d7f8eeb09cfba10','155c2a24cccce986528990fa6401d22ae727a8d49dc98dd64d2b752993a59923'
      ],
      xiaoqing1:['6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7','bebae681e51f6c6d61181a1068bd861766755848946f1839d649ca4933378a86','e18203affbefa3ae8a544f4932ba0c816acdee42026cebaccad62af898f1480b'],
      zjwc1:['a84d159a9cd6f2a605c4','ed8613d1bf8d958506bc','d072259f4d71223acd7d',
        '87120a5bd5bf5aa59401','79ae6653fec4d52adcd4','6ca615644f81185d6e96'],
      jsgx:['208538fad40c9796ec00','08de207541e54d033eb7','66046cfed9f87891115e','f0760f6cfe8d319e3bef','a1254894a9a764c6816b','8625b7a0955d398442a4','d1d4707e543526a059e2','480ea6b22f8ffa50e136','0e2399938ab77f5b91cc'],
      jstb:['f3d4eb9d4acfeccbd1bf','6888ae8ac48159ec2fa3','dce582c5ba18e4763eb6','9855ab445099a15b00e7','78e3e38db1293782c583'],
      ysgx:['9a3be560564b951550a6','c77c4948b07e8322c93f','e45ffb7db04197a72fe1','de4a95c9472a36aa9e38','586f137a4a132e09c285'],
      zuoen:['c2a16d4047d3d096b2700701fb5caba784e3c1031903fc8207b97b56909ab7a7'],
      marryu:['873a63615f6e42478a3b','1c96ea51e138b5a10655','01739c18a49cff216f35','d9dadce1a1edf45a862d','a99e101d860a977cb6dd','baa7f15045eed2cf32d5'],
      tangtang:['6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7','9b55a36056fc763032940328e0591cca386bf6b186d710e9f01ed275154a96f8','a823e200bc8f6a8edbbb56335c65ef65aa9bfa6e67f902ef073a28c97608ee71','16e6fff7524a94b079988e02666c34df673eb83ca021d958bc71ae2e141d10eb','6fbc3e0801e3baff097d6e7b3b4e4fd90d0d8587efa063f33777b7a31aa6b0a8'],
      yx:['442b5166f881150e46b9','79f406ec252961769310','ba36dcea3137e116ae79',
      '9e18f3c554964048ac44','00f0c083cf777e77e185','0e1917559d9e93ce4b0b','31f09b92a6b5b2f11ac6','b98a585d4fe8316710a4','6357f7b3b1e16e28171f','784e3f170e50b29688cc',
      '22dc85bba6567bdad22a','00b81a9fe132dac07668','6eddd3ee5768e94e4301','ad1ef2553cb1a3844100','55085e672d1e8a80f992','731a4bc517e815cf0df2','d9ad29be8ddff6d149f6',
      'a3172990b528aa3adefa','e9675a96e1b0e95ebb2b',
        '6a154ac3b7af61ed6548',
        '97fbc72a34295b4c0ec8',
        'd3fdda946f5624cdb492',
        '0959f969013a57d31371',
        '340886508210f0f501dd',
        'efbfa39641cac31ffad5',
        '7d52a9294d446255ae1a',
        'fdb2a6f29d62c80c0284',
        '470771cd88a81932af63'
      ],
      jz:['9c84ff01b2002c313f78','9ec83abe20e3ad60eb53','b0ca65ba000335d4c0dd','7502e46e04191ab85503','7a64bbfbffb03624a5a2','ebfaa67832321c9da17f','90db4c79cfa27156cd3b'],
      jztoken:['c72108312e413d84f674126066559f622dced5fe853a28e8d24064b19c9b56c2'],
      fjwc:['0df944cca119c270225a',
        '3399e2d64883f8380d63','efcdca45ba190a8fac43',
        '523232813295c58319d9','c4a990831562f25a58be',
        '9db7b3816397c12af284','a66e2afd3fd50539e5ec'
        ,'9071fd2d5b9b757b9b2d','2626b6fcdf4d91dff0fc',
        '091fe378ca7aa0bb5c94','103e87eb2d92bc66047b','4003ecf9ea17d42a9c03','fe40c7a6030b5b3e9c95','2cc7a556dd567c45a608',
        '716b52a489c8da4a56d9','c01ec4bc93b0c7dd4c54','8827f3e71c29b5dfe6e5','c65f194a303422fe2d11','032d4a2d87dac1ccb9e5','619c1a576a7f3304caa5','059eef7825360cb4a212'
        ,'54993d3787a9ef0fe149'

        ,'994ec93d6be3ed538e89'
        ,'41e8bb616490ba258ade',
        ,'2ba3b02edc28079b01d7',
        ,'09c462e84a813192c626',
        ,'c8713c32b75a12e579ee',
        ,'3b1e40d2cf7c3a3400d2',
        ,'cca95f8d5929c890b801',
        '46e17af4e642a9f1c95e',
        '206800ac3a7ce2cd9fb2',
        '65a54ca6aa6c0cbd0377',
        'a4b09c262218a0d9e899',
        'f99351cf00ce71864f55',

        'a627727949470658e649',
        'b211fa46ccf93cc5ea67',
        '3ee81a0af2bcc7a49fe3',

        'f0dbcc39634a091fd69b',
        'af7d5d94f138668226ab',
        'd58d2e06d91f1fcc1734',
      ],
      hqyt:['c96e23acbd5fd6e7cb66','4ed4a08ef7c07d504252'],
      kmcs:[
        '2ade6393de6e79f9a84a',
        '8fc5383e3ba9248c1e79',
        '814210595e9fae5baaa4',
        '663902cb3276598cb845',
        'e3d829f61be11567984d',
        '8c6f7da7a8500e917501',

      ],
      kmcstoken:['a6cc5426b4c65d9c5040c47a4f9c89d8d559f41e0b2ce0e7e65f7a3fd7acb9e6'],
      zer:[
        '5b1af45ef6a8563c697a',
        '01afe82d1fdc5f68fa19',
        'cbb2ee601e6831ebf9e9',
        'b4e129ce38fe4d111a13',
        '1f1eaf8b4cb0813b9dc8',
        '2b5e90d8af1a0f00377a',
        '6f04261ad68c50ad3465',
        'e020850e97017c0256dd',
        '216d314721309e5572f7',
        '5608aa0a08b938816215',
        '6d2ede6da16bb9901122',
        '1b09350903627470dbf1',
        '0406cc1063dfc35db2f9',
        'ebb451edd9e5e0a666df',
        '46cd5e97891e6d196df0',
      ],
      hy:['f6763ef4c7cca7225efb','d09cf958a84e5de25416','6f963ee7ef2204842267','50ac080cad4cff36ffc3','df7d6ac7df84f181a688','a25ab586a3553ff8eaf1','9deac08f2e3673ad300f','feaf67bcda0c309738ef','3d0b2634f608542d1192','4eaf5ef1fd96e08adae5','a792ffc806e9f33e292f','b2e529e765d0b0e5912e','906401571e91d8291402', '524b9ab96ac72038628f','2a5ce625e65e99284120','e3d11badf345bc4f0741',
        '0d98a87a735b5c65f336','17508515f18f416f5e59','c0603a5cb631ed0be6da','b8db99e2656e2a0ec32f','4357fefbc7f2e33ad75c','2881c6532d20213bde56', '830165add00acbf602b7','f328ba502923cf699f5d','73673fbd251d2b0124d9','2b68fce0d791a7fbc6da'],
      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      money:200,
      value3:'',
      time:'',
      value1: '',
      value2: '',
      datas:[],
      datadata:[],
      temp:[],
      temp1:[],
      temp2:[],
      startDate:'20220701',
      endDate:'20220710',
      namedata:[],
      datanums:[
        {
          nuMshowCount:0,
          nuMclickCount:0,
          nuMspent:0,
          nuMformsubmitCount:0,
          nuMdisGeneralBalance:0,
          nuMbalance:0,
          nuMcustomPayCount:0,
          nuMreactivation:0,
          nuMcustomRetainCount:0
        }
      ],
      ctrJson:[{
        flag:false,
        nameid:'',
        CTR:0,
        CVR:0,
        CLR:0,
        but:0,
        zdycl:0,
        zdyff:0,
        zdylh:0

      }],
      playCode:[],
      TempData:[],
      table:false,
      dialog: false,
      dialog1:false,
      HourList:[],
      Hourmap:new Map,
      sums:0,
      flag:true,
      form:[],
      group:{},
      kaiguan:0,
      activeName: 'first',
      grouplist:{},
      dingshi:true,
      xiane:true,
      sks:''



    }
  },

  methods:{


    //面板状态
    boo(tab) {
      if(tab.name==="first"){
        this.kaiguan=0
      }else if (tab.name==="second"){
        this.kaiguan=1
      }

    },

    //限额方法提交
    updateEd(){
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }else {
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }


      this.dialog1=false

    },

    //投放时间方法提交
    updateTime(){
      let endtime='2038-01-19'
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }
      else {
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }

      this.dialog = false
    },

    //限额
    edit1(row){
      console.log(row)
      this.grouplist={}
      this.grouplist={
        campaignId:row.campaignId,
        userId:row.userId,
      }
      this.dialog1=true
    },

    //投放日期
    edit(row){
      this.grouplist={}
      this.grouplist={
        userId:row.userId,
        groudId:row.groupId
      }

      this.dialog=true
      return row
    },

    //显示表单
    handleClick(row){
      this.HourList=[],
        this.TempData=[],
        this.TempData.push(row)
      for (let key=1;key<=this.Hourmap.size;key++){
        // console.log(this.Hourmap.get(key))
        for (let keys=0;keys<this.Hourmap.get(key).length;keys++){
          // console.log(this.TempData.campaignId)
          if(this.Hourmap.get(key)[keys].campaignId===this.TempData[0].campaignId){

            this.HourList.push(this.Hourmap.get(key)[keys])
          }
        }
      }
      let str=[{
        nameid:'',
        balance:'',
        chengben:''
      }];
      str[0].nameid=this.TempData[0].nameid;
      str[0].balance=this.TempData[0].balance;
      for(let i in this.HourList){
        console.log(this.HourList[i].spent)
        console.log(this.HourList[i].formsubmitCount)
        if (this.HourList[i].formsubmitCount===0){
          str[0].chengben=this.HourList[i].spent
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }else {
          str[0].chengben=this.HourList[i].spent/this.HourList[i].formsubmitCount
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }


        this.HourList[i]=this.hb(this.HourList[i],str[0])
      }
      this.table=true



      // get发送请求获取本条的投放时间
      // 生成折线图


    },

    //切换开关
    changeSwitch(value,row,index){
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      const { id,pauseState,userId} = row
      let params = {
        userId:userId,
        id:id,
        pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
      };

      this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token='+this.sks+'&timestamp='+
        time1+'&nonce='+nonce+'&advertiser_id='+params.userId,{
        ids:params.id,
        startAndStop:params.pauseState
      }).then(async res=> {
        if (res.data.code === 0) {
          this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
        }
      })

    },

    //限额显示的规则
    rule1(row,column){
      if (row[column.property]===-1){
        return '未限额'
      }else {
        var percent = row[column.property]/100000
        return percent
      }
    },
    //总汇规则
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (this.values==="ACCOUNT"){ //账户层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }

          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 10) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 12) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 14) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {

            return;

          }

          if (index === 16) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="CAMPAIGN"){ //计划层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }
          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(2);
            sums[index]=sums[index]/10
            sums[index]= sums[index]+'%'
            sums[index]=sums[index]
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }     if (index === 12) {

            return;

          }
          if (index === 14) {
            sums[index] = sums[index-5]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }

          if (index === 16) {
            sums[index] = sums[index-7]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 18) {
            sums[index] = sums[index-9]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 19) {

            return;

          }if (index === 20) {

            return;

          }

          if (index === 21) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="GROUP"){ //广告组层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }  if (index === 9) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index] =  sums[index].toFixed(2) ;
            return;

          }
          if (index === 6) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index]*100
            sums[index]=sums[index].toFixed(2);
            sums[index]= sums[index]+'%'
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 13) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 16) {
            sums[index] = sums[index-8]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }
          if (index === 17) {
            sums[index] = sums[index-5]/sums[index-9];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }



          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }
    },

    //导出表单api
    exportExcel () {
      /* generate workbook object from table */
      var xlsxParam = { raw: false } // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam)

      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '数据导出.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout)
        }
      }
      return wbout
    },

    //规则
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },
    rule2(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]/100000).toFixed(2)
        return percent
      }
    },
    //查询时间选择器函数
    ChangeToPercentage: function(row, column) {
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },

    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      console.log(this.time)
      this.value2=value1;

    },

    //渲染data、数据处理通用方法
    windowList(){
      //渲染页
      this.temp=JSON.parse(JSON.stringify(this.datadata))
      this.temp1=JSON.parse(JSON.stringify(this.namedata))
      this.temp3=JSON.parse(JSON.stringify(this.playCode))
      for (let key = 0; key < this.temp.length; key++) {
        this.ctrJson[0].flag=false;
        let t=0;
        this.ctrJson[0].nameid=this.temp1[key].name
        this.temp1[key].balance = this.temp1[key].balance / 100000
        this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
        if (this.temp2[key].spent===0){
          this.ctrJson[0].but=0
        }else if (this.temp2[key].formsubmitCount===0){
          this.ctrJson[0].but=this.temp2[key].spent
        }else {
          this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
        }

        this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
        this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
        let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
        this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);



        this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
        this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
        let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
        this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
        this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
        this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
        let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
        this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdycl=0
        }else if (this.temp2[key].customRetainCount===0){
          this.ctrJson[0].zdycl=this.temp2[key].spent
        }else {

          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
        }




        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdyff=0
        }else if (this.temp2[key].customPayCount===0){
          this.ctrJson[0].zdyff=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
        }


        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdylh=0
        }else if (this.temp2[key].reactivation===0){
          this.ctrJson[0].zdylh=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);
        }




        //  限额提醒代码
        if(this.temp3[key].dailyBudget!=-1){
          t=this.temp3[key].dailyBudget/100000
          t=t*0.8
          if (this.temp2[key].spent>=t){
            this.ctrJson[0].flag=true;
          }
        }
        this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
        this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])
      }
      this.temp2=JSON.parse(JSON.stringify(this.temp2))
      this.datas=this.temp2
      console.log(this.temp2)
      this.isDisable = false
      if (this.value==="DAY"){
        this.flag=false;
        if (this.values==="GROUP"){
          this.dingshi=true;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=true;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }else if (this.value==="HOUR"){
        this.flag=true;
        if (this.values==="GROUP"){
          this.dingshi=false;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=false;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }

      this.loading=false
    },


    //查询广告效果api
    async PostListQuery(parms){

      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a], {
        startDate: parms.startDate,
        endDate: parms.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: parms.summaryType,
        level: parms.level
      }).then(async resp => {

        console.log(resp.data.code)
        if (resp.data.code!==60806)
        {
          if (resp.data.data.items !=null){
            if (this.value==="HOUR"){
              // 存取小时的数据[]
              this.sums=this.sums+1;
              console.log(resp.data.data.items)
              this.Hourmap.set(this.sums,resp.data.data.items)

              // console.log(this.Hourmap.get(parms.a))
              let arr=[];
              let map=new Map;
              for(let key in resp.data.data.items){
                var time=new Date(resp.data.data.items[key].reportTime)
                let reTimeHour=time.getHours(); //获取返回整点时间
                var date=new Date()
                let hour=date.getHours();  // 获取当前时间
                if (hour===reTimeHour){
                  arr.push(key)   //定位现在整时位置
                  map.set(key,resp.data.data.items[key])// 记录下现在的数据
                }
              }
              for (let keys in arr){

                this.datadata.push(map.get(arr[keys]))
                let obj={
                  ids:resp.data.data.items[arr[keys]].campaignId,
                  lengths:arr.length
                }
                let pams=Object.assign(obj,parms)
                await this.PostListplayCode(pams)
              }
              let obj1={
                lengths:arr.length
              }
              parms=Object.assign(obj1,parms)
              await this.GetListUserId(parms);

            }else{
              console.log(resp.data.data.items)
              for (let b=0;b<resp.data.data.items.length;b++){
                this.datadata.push(resp.data.data.items[b])
                let obj={
                  ids:resp.data.data.items[b].campaignId,
                  lengths:resp.data.data.items.length
                }
                let pams=Object.assign(obj,parms)
                await this.PostListplayCode(pams)
              }
              let obj1={
                lengths:resp.data.data.items.length
              }
              parms=Object.assign(obj1,parms)
              await this.GetListUserId(parms);
            }

          }
        }

      })

    },

    //修改限额api
    async PostGroup(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditDate?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "startDate":pams.startDate,
          "endDate":pams.endDate
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放日期失败，请检查日期是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放日期成功',
            type: 'success'
          });
        }

      })


    },

    //修改投放日期api
    async PostMoeny(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/editDailyBudget?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "id":pams.id,
          "dailyBudget":pams.dailyBudget,

        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改限额失败，请检测限额是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改限额成功',
            type: 'success'
          });
          this.getDataList()
        }

      })


    },
    //查询账号信息api
    async GetListUserId(parms){
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a])
        .then(async res => {
            if (res.data.message == '请求成功') {
              //测试
              if (this.value==="HOUR"){
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }else{
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }
            } else {
            }
          }

        )
    },
    // 查询计划状态api
    async PostListplayCode(pams){
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token='+ pams.token + '&timestamp=' + this.time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid[pams.a],
        {
          "ids":pams.ids,
        }).then(resps=>{
        if (resps.data.data.list===undefined){
          this.playCode.push({pauseState:1})
        }else {
          console.log(resps.data.data.list[0])
          this.playCode.push(resps.data.data.list[0])
        }
      })
    },

    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },


    getDataList() {
      this.loading=true
      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount=0
      this.datanums[0].nuMclickCount=0
      this.datanums[0].nuMspent=0
      this.datanums[0].nuMformsubmitCount=0
      this.datanums[0].nuMbalance=0
      this.datanums[0].nuMdisGeneralBalance=0
      this.datanums[0].nuMcustomPayCount=0
      this.datanums[0].nuMreactivation=0
      this.datanums[0].nuMcustomRetainCount=0
      this.datas=null
      this.datadata=[]
      this.namedata=[]
      this.playCode=[]
      this.temp2=[]
      this.temp1=[]
      this.temp=[]
      if(this.userUalue[0]==="tangtang"){
        this.isDisable = true
        this.TimeChange();
      }
    },


    async TimeChange () {
      if (this.userUalue[1]==="fjwc"){
        for (let a = 0; a < this.fjwc.length; a++) {
          if(a===this.fjwc.length-1){

            console.log(this.sks)
            let parms={
              a:a,
              startDate:this.value2.at(0),
              endDate: this.value2.at(1),
              summaryType: this.value,
              level: this.values,
              token:this.tangtang[0],
              adid:this.fjwc
            }
            await this.PostListQuery(parms)
          }else {
            this.sks=this.tangtang[1]
            let parms={
              a:a,
              startDate:this.value2.at(0),
              endDate: this.value2.at(1),
              summaryType: this.value,
              level: this.values,
              token:this.sks,
              adid:this.fjwc
            }
            await this.PostListQuery(parms)
          }
        }
        //渲染页面
        this.windowList()

      }
      else if(this.userUalue[1]==="ttgx"){
        this.sks=this.ttgxtoken[0]
        this.sums=0;
        for (let a = 0; a < this.ttgx.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.ttgx
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="ycsq"){
        this.sks=this.ycsqtoken[0]
        this.sums=0;
        for (let a = 0; a < this.ycsq.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.ycsq
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="hy"){
        this.sks=this.tangtang[2]
        this.sums=0;
        for (let a = 0; a < this.hy.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.hy
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="hjh"){
        this.sks=this.hjhtoken[0]
        this.sums=0;
        for (let a = 0; a < this.hjh.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.hjh
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="kmcs"){
        this.sks=this.kmcstoken[0]
        this.sums=0;
        for (let a = 0; a < this.kmcs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.kmcs
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="jhcs"){
        this.sks=this.jhcstoken[0]
        this.sums=0;
        for (let a = 0; a < this.jhcs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.jhcs
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="zjwc"){
        this.sks=this.tangtang[0]
        this.sums=0;
        for (let a = 0; a < this.zjwc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zjwc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }
      else if(this.userUalue[1]==="yx"){
        this.sks=this.tangtang[3]
        this.sums=0;
        for (let a = 0; a < this.yx.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.yx
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      else if(this.userUalue[1]==="hqyt"){

          this.sks=this.tangtang[4]
          this.sums=0;
          for (let a = 0; a < this.hqyt.length; a++) {
            let parms={
              a:a,
              startDate:this.value2.at(0),
              endDate: this.value2.at(1),
              summaryType: this.value,
              level: this.values,
              token:this.sks,
              adid:this.hqyt
            }
            await this.PostListQuery(parms)
          }
          //渲染页面
          this.windowList()
        }
        //渲染页面

      else if(this.userUalue[1]==="zer"){

        this.sks=this.tangtang[4]
        this.sums=0;
        for (let a = 0; a < this.zer.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zer
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }

      else if(this.userUalue[1]==="jz"){

          this.sks=this.jztoken[0]
          this.sums=0;
          for (let a = 0; a < this.jz.length; a++) {
            let parms={
              a:a,
              startDate:this.value2.at(0),
              endDate: this.value2.at(1),
              summaryType: this.value,
              level: this.values,
              token:this.sks,
              adid:this.jz
            }
            await this.PostListQuery(parms)
          }
          //渲染页面
          this.windowList()

        //渲染页面


      }
      else if(this.userUalue[1]==="bxm"){

        this.sks=this.bxmtoken[0]
        this.sums=0;
        for (let a = 0; a < this.bxm.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.bxm
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

        //渲染页面


      }
      if (this.userUalue[1]==="ljs"){
        this.sks=this.ljstoken[0]
        this.sums=0;
        for (let a = 0; a < this.ljs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.ljs
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="bbkj"){
        this.sks=this.bbkjtoken[0]
        this.sums=0;
        for (let a = 0; a < this.bbkj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.bbkj
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="bxhx"){
        this.sks=this.bxhxtoken[0]
        this.sums=0;
        for (let a = 0; a < this.bxhx.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.bxhx
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
    },

  },
  created () {  },
}
</script>




// WEBPACK FOOTER //
// src/components/tangtang.vue